// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"e28dbd32","684":"a6d4d932","720":"5faaa56d","751":"72a713c0","813":"2a6c3a6f"}[chunkId] + ".chunk.js";
};